import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services/api';
import { showToastSuccess } from 'src/utilities/toast';

type AutoCreateTagsParams = {
  criteria?: string;
  specialty_id?: string;
  documents?: string[];
};

export const useAutoCreateTags = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['autoCreateTags'],
    mutationFn: (params: AutoCreateTagsParams) =>
      api.post('/v3/tag/auto_create', params).then(({ data }) => {
        showToastSuccess(data?.message || 'Tags created successfully');
        return data;
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tagList'] });
    },
  });
};
